import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ALGOLIA_SEARCH_FEATURE_KEY, AlgoliaSearchState } from './algolia-search.reducer';

export const selectAlgoliaSearchState = createFeatureSelector<AlgoliaSearchState>(ALGOLIA_SEARCH_FEATURE_KEY);

export const selectAlgoliaSearchSettings = createSelector(selectAlgoliaSearchState, (state) => state.settings);
